"use client";

import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useCategories } from "@/app/hooks/use-categories";
import Link from "next/link";

interface Announcement {
  text: string;
  href: string;
}

export function AnnouncementBar() {
  const { categories, isLoading } = useCategories();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);

  useEffect(() => {
    const discountAnnouncements: Announcement[] = [
      { text: "5000 TL Üzeri Alışverişlerde Kargo Ücretsiz!", href: "/" }
    ];
    categories?.categories
      .filter((cat) => cat.percentage)
      .forEach((cat) => {
        discountAnnouncements.push({
          text: `${cat.category} albümlerinde sepette %${cat.percentage} indirim!`,
          href: `/albumler/${cat.url}`,
        });
      });
    categories?.canvasCategories
      .filter((cat) => cat.percentage)
      .forEach((cat) => {
        discountAnnouncements.push({
          text: `${cat.category} kategorisinde sepette %${cat.percentage} indirim!`,
          href: `/kanvas/${cat.url}`,
        });
      });
    categories?.printCategories
      .filter((cat) => cat.percentage)
      .forEach((cat) => {
        discountAnnouncements.push({
          text: `${cat.category} baskılarında sepette %${cat.percentage} indirim!`,
          href: `/baskilar/${cat.url}`,
        });
      });
    categories?.giftCategories
      .filter((cat) => cat.percentage)
      .forEach((cat) => {
        discountAnnouncements.push({
          text: `${cat.category} hediyelerinde sepette %${cat.percentage} indirim!`,
          href: `/hediye/${cat.url}`,
        });
      });

    if (discountAnnouncements.length === 0) {
      discountAnnouncements.push({
        text: "Kampanyalara göz atın! 🎁",
        href: "/",
      });
    }

    setAnnouncements(discountAnnouncements);
  }, [categories]);

  useEffect(() => {
    if (announcements.length <= 1) return;

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === announcements.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [announcements.length]);

  const defaultAnnouncement = (
    <div className="bg-gray-600 text-white py-2">
      <div className="container mx-auto px-4">
        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center text-sm font-medium"
        >
          Yükleniyor...
        </motion.p>
      </div>
    </div>
  );

  if (isLoading || announcements.length === 0) {
    return defaultAnnouncement;
  }

  return (
    <div className="bg-gray-700 text-white py-2 overflow-hidden h-[40px]">
      <div className="container mx-auto px-4">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
            className="text-center"
          >
            <Link
              href={announcements[currentIndex].href}
              className="text-sm font-medium hover:underline inline-block text-nowrap"
            >
              {announcements[currentIndex].text} 🎁
            </Link>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
